import type { FillLayerSpecification, VectorSourceSpecification } from 'mapbox-gl';

export const AT_STATES_SOURCE_ID = 'states';
export const AT_STATES_LAYER_NAME = 'states';

export const AT_STATES_LAYER_CONFIG: FillLayerSpecification = {
  id: AT_STATES_LAYER_NAME,
  type: 'fill',
  source: AT_STATES_SOURCE_ID,
  'source-layer': 'states',
  paint: {
    'fill-outline-color': 'rgba(0,0,0,0.3)',
    'fill-color': 'rgba(0,0,0,0.1)',
  },
};

export const AT_STATES_SOURCE: VectorSourceSpecification = {
  type: 'vector',
  url: 'mapbox://sseemann.at-states-dev',
};

export interface AT_STATES_SOURCE_FEATURE_PROPERTIES {
  color: string;
  displayName: string;
  key: string;
}
